export default "__VITE_ASSET__DKBoL2AJ__"